import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Heading } from '@zillow/constellation';

import accessUtils from 'app/shared/utils/accessUtils';

import PaidInclusionActions from 'app/shared/actions/PaidInclusionActions';
import PropertiesActions from 'app/shared/actions/PropertiesActions';
import PaidInclusionSelectors from 'app/shared/selectors/PaidInclusionSelectors';
import { AppSelectors, UserSelectors } from 'app/shared/selectors';

import PaidInclusionPaymentModal from 'app/shared/containers/paidInclusion/PaymentModal';
import PaymentOptionsModal from 'app/shared/components/Modal/PaymentOptionsModal';

import SpinnerContainer from 'app/shared/components/SpinnerContainer';

// NOTE: KEEP as class
// has issues replacing credit card when refactoring into a functional component
class PaymentPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            displayOptionsModal: false,
            isPaymentValid: false,
            didLoadDetails: false,
        };
    }

    componentDidMount() {
        const {
            dispatch,
            hostApp,
        } = this.props;

        const listing = this.getListingFromPathName();

        dispatch(PaidInclusionActions.verifyPaymentAndActivateListing(listing, true, false, hostApp));
    }

    componentWillReceiveProps(nextProps) {
        const { didLoadDetails } = this.state;
        const {
            dispatch,
        } = this.props;

        const listing = this.getListingFromPathName();

        if (nextProps.isPaymentValid === null) {
            return;
        }

        if (nextProps.isPaymentValid) {
            // payment success callback to mobile apps.
            try {
                window.ZRM_NATIVE_API.onPaidInclusionPaymentMade('success');
            } catch (error) {
                console.error('ERROR: this function is intended to be triggered inside a WebView');
            }

            this.setState({
                isLoading: false,
                isPaymentValid: true,
            });
        } else {
            if (didLoadDetails) {
                return;
            }

            dispatch(PaidInclusionActions.details(listing.listingId)).then((response) => {
                const { isFlatFeeEnabled } = response;
                const { app } = this.props;
                const { appConfig, cookieEnabledServices } = app;

                const canAccessFlatFee = accessUtils.canAccessFlatFee({
                    isFlatFeeEnabled,
                    appConfig,
                    cookieEnabledServices,
                });

                this.setState({
                    isLoading: false,
                    displayOptionsModal: canAccessFlatFee,
                    didLoadDetails: true,
                });
            });
        }
    }

    getListingFromPathName() {
        const listingId = this.props.location.pathname.split('/')[3];

        return { listingId };
    }

    renderPaymentOptionModal() {
        return (
            <PaymentOptionsModal
                onOptionSelected={(type) => {
                    this.props.dispatch(PropertiesActions.updateCurrentProperty({
                        paidInclusionSelectedProductType: type,
                    }));

                    this.setState({
                        displayOptionsModal: false,
                    });
                }}
            />
        );
    }

    renderPaidInclusionPaymentModal() {
        const {
            user,
            hostApp,
            price,
            isEligibleForLeadGuarantee,
        } = this.props;

        const listing = this.getListingFromPathName();
        const { listingId } = listing;

        return (
            <PaidInclusionPaymentModal
                listing={{ listingId }}
                user={user}
                isRenderedInPageView={true}
                hostApp={hostApp}
                price={price}
                onChargeFail={() => {}}
                isEligibleForLeadGuarantee={isEligibleForLeadGuarantee}
            />
        );
    }

    renderLoading() {
        return (
            <SpinnerContainer size="sm" />
        );
    }

    renderPaymentValid() {
        return (
            <Heading level={5}>
                Payment is complete
            </Heading>
        );
    }

    renderComponent() {
        const { displayOptionsModal, isPaymentValid } = this.state;

        if (isPaymentValid) {
            return this.renderPaymentValid();
        }

        return (
            <div>
                <Heading level={6} className="PaymentPage-Title" />

                {displayOptionsModal
                    ? this.renderPaymentOptionModal()
                    : this.renderPaidInclusionPaymentModal()}
            </div>
        );
    }

    render() {
        const { isLoading } = this.state;

        return (
            <div style={{ marginLeft: '15px', marginRight: '15px', paddingBottom: '300px' }}>
                {isLoading ? this.renderLoading() : this.renderComponent() }
            </div>
        );
    }
}

PaymentPage.propTypes = {
    price: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
    app: AppSelectors.makeApp(state),
    hostApp: AppSelectors.makeHostApp(state),
    user: UserSelectors.makeUser(state),
    isPaymentValid: PaidInclusionSelectors.makeIsPaymentValid(state),
    price: PaidInclusionSelectors.makePrice(state),
    isEligibleForLeadGuarantee: PaidInclusionSelectors.makeIsEligibleForLeadGuarantee(state),
});

export { PaymentPage };
export default connect(mapStateToProps)(PaymentPage);
